<template>
    <Icon name="indent-left">
        <svg version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 330 330">
            <title>indent-right</title>
            <g id="XMLID_507_">
                <path
                    id="XMLID_508_"
                    d="M315,270H15c-8.284,0-15,6.716-15,15s6.716,15,15,15h300c8.284,0,15-6.716,15-15S323.284,270,315,270z"
                />
                <path
                    id="XMLID_509_"
                    d="M315,210H165c-8.284,0-15,6.716-15,15s6.716,15,15,15h150c8.284,0,15-6.716,15-15S323.284,210,315,210z"
                />
                <path
                    id="XMLID_510_"
                    d="M315,150H165c-8.284,0-15,6.716-15,15s6.716,15,15,15h150c8.284,0,15-6.716,15-15S323.284,150,315,150z"
                />
                <path
                    id="XMLID_511_"
                    d="M15,60h300c8.284,0,15-6.716,15-15s-6.716-15-15-15H15C6.716,30,0,36.716,0,45S6.716,60,15,60z"
                />
                <path
                    id="XMLID_512_"
                    d="M315,90H165c-8.284,0-15,6.716-15,15s6.716,15,15,15h150c8.284,0,15-6.716,15-15S323.284,90,315,90z"
                />
                <path
                    id="XMLID_515_"
                    d="M9.26,238.858c1.855,0.769,3.805,1.142,5.737,1.142c3.903,0,7.74-1.524,10.609-4.394l60-60
		c5.858-5.858,5.858-15.355,0-21.213l-60-60c-4.29-4.291-10.743-5.572-16.347-3.252C3.654,93.463,0,98.933,0,105v120
		C0,231.067,3.654,236.537,9.26,238.858z"
                />
            </g>
        </svg>
    </Icon>
</template>

<script>
import Icon from './icon';
export default {
    components: {
        Icon,
    },
};
</script>
